import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from "../../modules/shared.module";

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { DropzoneModule } from "ngx-dropzone-wrapper";
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { dropZoneSettings } from "../../settings/dropzone.settings";

// translation
import { TranslateModule } from '@ngx-translate/core';
import { MessagesPage } from './messages.page';

const routes: Routes = [
  {
    path: '',
    component: MessagesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild(),
    InfiniteScrollModule,
    SharedModule,
    DropzoneModule
  ],
  declarations: [MessagesPage],
  schemas: [ // this is because of dropzone...
     CUSTOM_ELEMENTS_SCHEMA,
     NO_ERRORS_SCHEMA
  ],
  providers: [
     {
         provide: DROPZONE_CONFIG,
         useValue: dropZoneSettings
     }
  ]
})
export class MessagesPageModule {}
